import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CurrentLocaleService} from "../services/current-locale.service";

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {

  constructor(
    private currentLocaleService: CurrentLocaleService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const locale = this.currentLocaleService.getCurrentLang()

    request = request.clone({
      setHeaders: {
        'Accept-Language': locale
      }
    })

    return next.handle(request);
  }
}
